import { ApolloLink, Observable } from "apollo-link";
import { ApolloEvents } from "./ApolloEvents";

class ApolloEventsLink extends ApolloLink {
	static Events = ApolloEvents;

	constructor(events = ApolloEvents()) {
		super(
			(operation, forward) =>
				new Observable(observer => {
					let handle;
					Promise.resolve(operation)
						.then(oper => {
							handle = forward(oper).subscribe({
								next: result => {
									this.events.notify(oper.operationName, oper.variables, result);
									return observer.next(result);
								},
								error: error => {
									this.events.notify(oper.operationName, oper.variables, { errors: error });
									return observer.error(error);
								},
								complete: observer.complete.bind(observer),
							});
						})
						.catch(observer.error.bind(observer));

					return () => handle?.unsubscribe();
				}),
		);

		this.events = events;
		this.on = this.events.on;
		this.onError = this.events.onError;
	}
}

export default ApolloEventsLink;
